import React from 'react';
import GGlobe from './Globe';

function App() {
  return (
    <div className="App">
      <GGlobe/>
    </div>
  );
}

export default App;
